export function formatEmailCustomisationFormValuesForApi({ delay, senderEmail, replyToEmail, }) {
    const delayNumber = delay ? parseInt(delay, 10) : undefined;
    return {
        delay: Number.isNaN(delayNumber) ? undefined : delayNumber,
        sender_email: senderEmail,
        reply_to_email: replyToEmail,
    };
}
